import { useState } from 'react';
import { useIntl } from 'react-intl';

import { acceptPrivacyPolicy } from 'src/api/UserApi';
import { Loader } from 'src/components/ui/Loader';
import { toastError, toastSuccess } from 'src/components/ui/toasts';
import { TermsAndConditionsForm } from 'src/forms/TermAndConditions/TermsAndConditionsForm';
import { useAppNavigate } from 'src/hooks/useAppNavigate';
import { useCurrentProvider } from 'src/hooks/useCurrentProvider';
import messages from 'src/messages/terms-and-conditions.messages';
import { Logger } from 'src/services/Logger';

import styles from './TermsAndConditionsPage.module.scss';

const HTML_AGREEMENT =
  "<iframe style='border:1px solid #b2c3c5;' src='https://templates.insights.allurion.com/data_sharing_agreement/data-sharing-agreement.html' width='100%' height='1500px'></iframe>";

export default function TermsAndConditionsPage() {
  const intl = useIntl();
  const { provider } = useCurrentProvider();
  const [isLoading, setIsLoading] = useState(false);
  const { toClinicPage } = useAppNavigate();

  const submitForm = async () => {
    try {
      setIsLoading(true);
      await acceptPrivacyPolicy();
      toastSuccess(intl.formatMessage(messages.agreeTermsSuccess));
      setIsLoading(false);
      toClinicPage();
    } catch (error) {
      Logger.captureException(error);
      toastError(intl.formatMessage(messages.agreeTermsFailure));
      setIsLoading(false);
    }
  };

  const initialValues = {
    firstName: provider?.FirstName,
    lastName: provider?.LastName,
    accepted: false,
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{intl.formatMessage(messages.title)}</h2>
      <div className={styles.text}>{intl.formatMessage(messages.agreeTerms)}</div>

      <div dangerouslySetInnerHTML={{ __html: HTML_AGREEMENT }} />
      <TermsAndConditionsForm initialValues={initialValues} onSubmit={submitForm} />
      <Loader isLoading={isLoading} />
    </div>
  );
}
